import { post } from "@insite/client-framework/Services/ApiService";
import { SendPriceMatchRequest } from "@preferredMedical/Models/ProductDetails/PriceMatch/SendPriceMatchRequest";
import { PriceRequestEmailRequest } from "@preferredMedical/Models/ProductDetails/PriceRequestEmailRequest";
import { PumpRentalEmailRequest } from "@preferredMedical/Models/ProductDetails/PumpRentalEmailRequest";

const priceMatchUrl = "api/v1/Product/PriceMatch";
const pumpRentalEmailUrl = "api/v1/Product/PumpRental";
const priceRequestUrl = "api/v1/Product/PriceRequest";

export function sendPriceMatch(model: SendPriceMatchRequest, files: File[]) {
    const xhr = new XMLHttpRequest();

    const formData = new FormData();
    let i = 0;
    formData.append(`data`, JSON.stringify(model));
    for (const file of files) {
        formData.append(`attachment_${i}`, files[i], file.name);
        i++;
    }

    xhr.open("POST", priceMatchUrl, false);
    xhr.send(formData);
    return xhr;
}

export function checkStatusCode(xhr: XMLHttpRequest) {
    if (xhr.status === 200) {return undefined;}
    return JSON.parse(xhr.responseText).message;
}

export async function sendPumpRentalEmail(model: PumpRentalEmailRequest){
    await post(pumpRentalEmailUrl, model);
}

export async function sendPriceRequestEmail(model: PriceRequestEmailRequest) {
    await post(priceRequestUrl, model);
}